const URL = '/resetear_saldos'
const state = {
  loading: false,
}

// GETTERS
const getters = {
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onSave ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, {
        cuenta_id: payload
      })
      .then(response => {
        commit('ResponseHTTP/addSuccess', 'El saldo de la cuenta fue recalculada', { root: true })
        resolve(response.data)
      })
      .catch(error => {
        commit('ResponseHTTP/addError', 'Error al recalcular el saldo de la cuenta', { root: true })
        reject(error)
      })
      .finally(() => {
        commit('setLoading', false)
      })
    })
  },
}

// MUTATIONS
const mutations = {
  setLoading (state, payload) {
    state.loading = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
